/**
 * Utility functions for generating IDs and other values
 */

/**
 * Generates a random 10-character alphanumeric reservation ID
 * with uppercase letters, lowercase letters, and numbers
 */
export const generateReservationId = (): string => {
  // Characters to use in the ID (uppercase, lowercase, and numbers)
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  
  // Generate a 10-character string
  let result = '';
  for (let i = 0; i < 10; i++) {
    // Get a random index into the chars string
    const randomIndex = Math.floor(Math.random() * chars.length);
    // Add the character at that index to our result
    result += chars.charAt(randomIndex);
  }
  
  return result;
}; 